import TileLinksBlock from './tile-links-block';

export default TileLinksBlock;
